import React, { FC, ImgHTMLAttributes } from 'react';
import { useInView } from 'react-intersection-observer';

import cx from 'classnames';

import LazyImageComponent, { ILazyImageProps } from './component';

export interface ILazyImage
  extends Pick<ILazyImageProps, 'preview'>,
    ImgHTMLAttributes<HTMLImageElement> {
  alt: string;
  wrapperClassName?: string;
  component?: React.JSXElementConstructor<any> | string;
}

const LazyImage: FC<ILazyImage> = ({
  wrapperClassName = 'inline',
  component: Component = 'div',
  ...props
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '400px 0px',
  });

  return (
    <Component className={cx(wrapperClassName)} ref={ref}>
      <LazyImageComponent inView={inView} {...props} />
    </Component>
  );
};

export default LazyImage;
